import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'route-itinerary-direction-link',
  templateUrl: './route-itinerary-direction-link.component.html',
  styleUrls: [
    './route-itinerary-direction-link.component.scss',
    '../../common/scss/route-itinerary-common.scss',
  ],
  standalone: true,
  imports: [CommonModule],
})
export class RouteItineraryDirectionLinkComponent {
  @Input() label: string;
  @Input() showDirectionLink: boolean;
  @Output() viewDirectionLink = new EventEmitter();

  constructor() {}
}
